import { render, staticRenderFns } from "./Infrastructure.vue?vue&type=template&id=d4712db4"
import script from "./Infrastructure.vue?vue&type=script&lang=ts"
export * from "./Infrastructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports